


























































































































































































































import { Component, Vue, Ref } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import {
  LearningRequest as ILearningRequest,
  StatusProfile as IProfile,
  LearningRequestEdit as ILearningRequestEdit
} from "@/api-v2/learning-requests/models";
import { Course as ICourse } from "@/api-v2/course/models/course";
import api, { courseApi, learningRequestApi } from "@/getinfo-api";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { getCurrentCompanyId, getCurrentEmployee } from "@/plugins/roles";
import StudentTable from "@/components/students/StudentTable.vue";

@Component({
  components: {
    StudentTable,
    CustomButton,
    CourseRegistrationsTable,
    TextField,
    CBlock,
    CPage
  }
})
export default class LearningRequest extends Vue {
  @Ref("registrationTable") registrationTable!: CourseRegistrationsTable;
  learningRequest!: ILearningRequest;
  course!: ICourse;
  profile!: IProfile;
  status!: string;
  isStatusChanging: boolean = false;
  responsibleId!: string;
  isAllowToAddStudents: boolean = false;
  isLoadingStudents: boolean = false;

  data() {
    return {
      learningRequest: undefined,
      responsibleId: undefined,
      course: undefined,
      profile: undefined,
      status: undefined
    };
  }

  get employee() {
    return getCurrentEmployee();
  }

  get editable() {
    return !this.learningRequest.registrationIds?.length;
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "orders" },
        label: `${this.$tc(this.$translate.LearningRequests)}`
      },
      {
        label: this.learningRequest.number
      }
    ];
  }
  get selectedCompany() {
    return getCurrentCompanyId();
  }

  async getLearningRequest() {
    await learningRequestApi.Request.getRequest(this.$route.params.id).then(
      res => {
        this.learningRequest = res.data;
        api.EmployeeApi.get(
          this.selectedCompany,
          this.learningRequest.responsibleId
        ).then(result => {
          this.responsibleId = result.data.user.id;
        });
        this.status = res.data.statusId;
      }
    );
  }

  async getCourse() {
    await courseApi.Course.getCourse(this.learningRequest.courseId).then(
      res => {
        this.course = res.data;
      }
    );
  }

  async getProfile() {
    await learningRequestApi.StatusProfiles.getProfile(
      this.learningRequest.profileId
    ).then(res => {
      this.profile = res.data;
    });
  }

  addStudents(students: any[]) {
    this.isLoadingStudents = true;
    let form: ILearningRequestEdit = {
      ...this.learningRequest,
      studentIds: [
        ...this.learningRequest.studentIds,
        ...students.map(({ id }) => id)
      ]
    };
    learningRequestApi.Request.editRequest(this.learningRequest.id, form)
      .then(() => {
        this.isAllowToAddStudents = false;
        this.init();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoadingStudents = false;
      });
  }

  removeStudents(students: any[]) {
    this.isLoadingStudents = true;
    let form: ILearningRequestEdit = {
      ...this.learningRequest,
      studentIds: [
        ...this.learningRequest.studentIds.filter(
          id => !students.map(({ id }) => id).includes(id)
        )
      ]
    };
    learningRequestApi.Request.editRequest(this.learningRequest.id, form)
      .then(() => {
        this.isAllowToAddStudents = false;
        this.init();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoadingStudents = false;
      });
  }

  changeStatus() {
    this.isStatusChanging = true;
    learningRequestApi.Request.changeRequestStatus(this.learningRequest.id, {
      statusId: this.status
    })
      .then(async res => {
        this.learningRequest = res.data;
        await this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Success)}`
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.status = this.learningRequest.statusId;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })

      .finally(() => {
        this.isStatusChanging = false;
      });
  }

  async init() {
    await this.getLearningRequest();
    await this.getProfile();
    await this.getCourse();
  }

  created() {
    this.init();
  }
}
